import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchEventDetailsThunk } from "../../redux/fetchProjectsThunk";
import html2pdf from "html2pdf.js";

const CelebrationDetailsTab = ({ item, category_id = 0 }) => {
  const dispatch = useDispatch();
  const contentRef = useRef();
  const faqsSectionRef = useRef();

  const categoryKey = category_id === 0 ? "celebration" : "awareness";

  const { faqs, loading, error } = useSelector(
    (state) => state.projects.eventDetails[categoryKey]
  );
  const [language, setLanguage] = useState("English");

  useEffect(() => {
    console.log("ITEM DEBUG:", item);
  }, []);

  useEffect(() => {
    if (item?.celebration_id) {
      console.log("✅ Dispatching fetchEventDetailsThunk");
      console.log("item:", item);
      console.log("category_id:", category_id); // should be 2
      console.log("event_id (celebration_id):", item.celebration_id);
      dispatch(
        fetchEventDetailsThunk({
          category_id,
          event_id: item.celebration_id,
          language,
        })
      );
    }
  }, [dispatch, category_id, item?.celebration_id, language]);

  const toggleAccordions = (element, expand) => {
    const collapses = element.querySelectorAll(".accordion-collapse");
    const buttons = element.querySelectorAll(".accordion-button");

    collapses.forEach((collapse) => {
      if (expand) collapse.classList.add("show");
      else collapse.classList.remove("show");
    });

    buttons.forEach((button) => {
      if (expand) {
        button.classList.remove("collapsed");
        button.setAttribute("aria-expanded", "true");
      } else {
        button.classList.add("collapsed");
        button.setAttribute("aria-expanded", "false");
      }
    });
  };

  const handleDownloadPDF = () => {
    if (faqsSectionRef.current) {
      toggleAccordions(faqsSectionRef.current, true);
      setTimeout(() => {
        html2pdf()
          .set({
            margin: 0.5,
            filename: `${item.name || "event-details"}_faqs.pdf`,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
          })
          .from(faqsSectionRef.current)
          .save()
          .then(() => toggleAccordions(faqsSectionRef.current, false));
      }, 100);
    }
  };

  const handlePrint = () => {
    if (faqsSectionRef.current) {
      toggleAccordions(faqsSectionRef.current, true);
      const printWindow = window.open("", "", "height=600,width=800");
      printWindow.document.write("<html><head><title>Print FAQs</title>");
      document.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
        printWindow.document.write(
          `<link rel="stylesheet" href="${link.href}">`
        );
      });
      printWindow.document.write("</head><body>");
      printWindow.document.write('<div class="container mt-4">');
      printWindow.document.write(faqsSectionRef.current.innerHTML);
      printWindow.document.write("</div></body></html>");
      printWindow.document.close();

      printWindow.onload = function () {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
        toggleAccordions(faqsSectionRef.current, false);
      };

      setTimeout(() => {
        if (printWindow && !printWindow.closed) {
          try {
            printWindow.focus();
            printWindow.print();
          } finally {
            printWindow.close();
            toggleAccordions(faqsSectionRef.current, false);
          }
        } else {
          toggleAccordions(faqsSectionRef.current, false);
        }
      }, 500);
    }
  };

  if (loading) {
    return <div className="alert alert-info">Loading details...</div>;
  }

  if (error) {
    return (
      <div className="alert alert-danger">Error loading details: {error}</div>
    );
  }
const applyMultiColumn = faqs && faqs.length > 10;
  return (
    <div className="card card-body" ref={contentRef}>
      {faqs && faqs.length > 0 ? (
        <>
          <div className="row">
            <div className="col-md-6 col-sm-6">
              <h3 className="my-0 text-18">Details related to {item.name}</h3>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="d-flex justify-content-end mb-3">
                <select
                  className="form-select"
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                  style={{ width: "150px", marginRight: "10px" }}
                >
                  <option value="English">English</option>
                  <option value="Hindi">Hindi</option>
                </select>
                <button className="btn btn-primary me-2" onClick={handlePrint}>
                  Print
                </button>
                <button className="btn btn-primary" onClick={handleDownloadPDF}>
                  Download
                </button>
              </div>
            </div>
          </div>

          <div ref={faqsSectionRef}>
            <div className="accordion " id="eventFaqAccordion" style={ { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '15px' }}>
              {faqs.map((faq) => (
                <div className="accordion-item " key={faq.id}>
                  <h2 className="accordion-header" id={`heading${faq.id}`}>
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${faq.id}`}
                      aria-expanded="false"
                      aria-controls={`collapse${faq.id}`}
                    >
                      {faq.question}
                    </button>
                  </h2>
                  <div
                    id={`collapse${faq.id}`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`heading${faq.id}`}
                    data-bs-parent="#eventFaqAccordion"
                  >
                    <div
                      className="accordion-body"
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        <div className="alert alert-info mt-3">
          <h4 className="alert-heading">
            No specific details available yet for "{item.name || item.details}".
          </h4>
          <p>This content will be updated dynamically once available.</p>
        </div>
      )}
    </div>
  );
};

export default CelebrationDetailsTab;
